export interface CreditQuery {
  orderDirection: string;
  status: CreditStatus[];
}

export enum CreditStatus {
  UNPAID = "UNPAID",
  PAID = "PAID",
  LATE = "LATE",
  CANCELLED = "CANCELLED",
  DELETED = "DELETED",
}
export interface PaymentPlans {
  data: DebtType[];
  meta: MetaType;
}

export interface PaymentPlansDetail {
  id: number;
  creditId: number;
  status: CreditStatus;
  creditAmount: number;
  totalPaidAmount: number;
  totalPaidLateAmount: number;
  totalPaidServiceFee: number;
  createdAt: string;
  dueDate: string;
}

export interface MetaType {
  current: number;
  total: number;
}

export interface Pagination {
  page: number;
  size: number;
}
export interface CreditSummary {
  totalAmount: number;
  totalLateAmount: number;
  activeCreditCount: number;
  lateCreditCount: number;
  masterpassAutoRepaymentEnabled: boolean;
}

export interface CreditSummaryTotal {
  totalAmount: number;
  activeCreditCount: number;
}
export interface CreditSummaryLate {
  totalLateAmount: number;
  lateCreditCount: number;
}

export interface DebtType {
  id: number;
  creditId: number;
  status: CreditStatus;
  creditAmount: number;
  paymentAmount: number;
  remainingBaseAmount: number;
  remainingPaymentAmount: number;
  totalRemainingLateAmount: number;
  baseInterestAmount: number;
  totalAmount: number;
  baseAmount: number;
  snoozeAmount: number;
  totalRemainingAmount: number;
  serviceFee: number;
  remainingServiceFee: number;
  createdAt: string;
  dueDate: string;
  totalPaidAmount: number;
  snoozeAvailable: boolean;
  maxSnoozeDuration: number;
  shop: {
    id: string;
    name: string;
    logoUrl: string;
  };
}
